import React from 'react';
import type { Node } from '@xyflow/react';
import { createImmerStore } from '@/state/createImmerStore';
import { useWorkspace } from "@/context/workspace";

interface NodeSelectionState {
  selectedNode: Node | null;
  selectNode: (node: Node | null) => void;
  reset: () => void;
}

// Zustand store with Immer for consistent draft-style updates
const useNodeSelectionStore = createImmerStore<NodeSelectionState>((set) => ({
  selectedNode: null,
  selectNode: (node) => set((draft) => {
    draft.selectedNode = node;
  }),
  reset: () => set((draft) => {
    draft.selectedNode = null;
  }),
}));

// Provider listens for workspace changes and resets local selection
export function NodeSelectionProvider({ children }: { children: React.ReactNode }) {
  const { wsChangeCount } = useWorkspace();
  const store = useNodeSelectionStore();
  React.useEffect(() => {
    store.reset();
  }, [wsChangeCount]);
  return <>{children}</>;
}

export function useNodeSelection(): NodeSelectionState {
  return useNodeSelectionStore();
}
